<template>
  <b-col lg="10">
    <b-form-group class="text-left"
                  label-class="font-weight-bold pt-0"
                  :label="textQuestion">
      <b-form-textarea
          v-model="text"
          placeholder=""
          max-rows="4"
          :rows="rows"
          :name="config.dependsOn.codeQuestions"
          :id="config.dependsOn.codeQuestions"
          @input="actionOutput"
      ></b-form-textarea>
    </b-form-group>
  </b-col>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'FormShowTextEditorIf',
  props: {
    config: {
      type: Object,
      default: () => {}
    },
    value: {
      type: Object,
      default: () => {}
    },
    schemaForms: {
      type: Array,
      default: () => { return [] }
    },
    rows: {
      type: Number,
      default: 6
    }
  },
  data () {
    return {
      code: '',
      textQuestion: '',
      point: 0,
      text: '',
      isOpen: false
    }
  },
  computed: {
    getCode () {
      const code = this.config.dependsOn.codeQuestions
      return code
    }
  },
  watch: {
    value (val) {
      console.log('this.text', val)
      if (val) {
        const code = this.config.dependsOn.codeQuestions
        const codeQuestion = this.config.codeQuestion
        const _text = val[`${codeQuestion}_${code}`]
        if (!_.isUndefined(_text)) {
          this.text = _text
        } else {
          this.text = null
        }
      } else {
        this.text = null
      }
      console.log('this.text', this.text)
    },
    config (val) {
      console.log('config', val)
      this.initComponent()
    }
  },
  mounted () {
    console.log('mounted')
    this.initComponent()
  },
  methods: {
    initComponent () {
      this.text = null
      if (!this.isShowPage()) {
        this.actionSkipPage()
      } else {
        console.log('searchQuestion')
        this.searchQuestion()
      }
    },
    actionSkipPage () {
      this.$emit('skip-this-page')
    },
    isShowPage () {
      const code = this.config.dependsOn.codeQuestions
      const point = this.value[code]
      console.log(code, point)
      const ranges = this.config.dependsOn.ranges
      console.log(ranges.from <= point && point <= ranges.to)
      return ranges.from <= point && point <= ranges.to
    },
    searchQuestion () {
      let items = []
      _.forEach(this.schemaForms, (page) => {
        items = _.concat(items, page)
      })
      const code = this.config.dependsOn.codeQuestions
      const question = _.find(items, {codeQuestion: code})
      const point = this.value[code]

      if (!_.isUndefined(question)) {
        this.textQuestion = this.config.textQuestion
          .replace('{textQuestion}', question.textQuestion)
          .replace('{point}', point)
        this.setTextTo()
      } else {
        this.actionSkipPage()
      }
    },
    actionOutput (val) {
      if (val.length === 0) {
        return
      }
      const codeQuestion = this.config.codeQuestion
      const code = this.config.dependsOn.codeQuestions
      const item = {
        codeQuestion: `${codeQuestion}_${code}`,
        value: val
      }
      this.$emit('action-output', item)
    },
    setTextTo () {
      const code = this.config.dependsOn.codeQuestions
      const codeQuestion = this.config.codeQuestion
      const _text = this.value[`${codeQuestion}_${code}`]

      if (!_.isUndefined(_text)) {
        this.text = _text
      } else {
        this.text = null
      }
      console.log('setTextTo', this.text)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/form/FormShowTextEditorIf.vue